/* unplugin-vue-components disabled */import { render } from "./IconList.vue?vue&type=template&id=23391bc0&scoped=true"
import script from "./IconList.vue?vue&type=script&lang=js"
export * from "./IconList.vue?vue&type=script&lang=js"

import "./IconList.vue?vue&type=style&index=0&id=23391bc0&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23391bc0"]])

export default __exports__